module.exports = __webpack_public_path__ + "media/images/account-add-photo-275e7cba45b63738cd16492d9935decb.svg";